// 我的帳號（使用者選單，/settings；SPEC #vms-web-220「我的帳號」、#vms-web-845，VMS UX 評審 2026-10-13 P1-10）——個人的設定：
//   安全性（兩步驟驗證、passkey、登入裝置、API 金鑰、我的存取紀錄）｜通知（NOTIF-02）｜分享給我｜本地 VMS（這台電腦的登記）｜開發者帳號（SPEC #account-split-ui）。
// 組織相關的（組織資料、安全政策、MyCam 政策）在「組織管理 › 組織設定」（/org）；場域樹在「組織與場域」（/sites）。
import { NavLink, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SecuritySection } from './SecuritySection';
import { SessionsSection } from './SessionsSection';
import { ApiKeysSection } from './ApiKeysSection';
import { PasskeysSection } from './PasskeysSection';
import { SsoLinksSection } from './SsoLinksSection';
import { NotifySection } from './NotifySection';
import { SharedWithMeSection } from './SharedWithMeSection';
import { MyAccessLogSection } from './MyAccessLogSection';
import { LocalVmsSection } from './LocalVmsSection';
import { LocalVmsApprove } from './LocalVmsApprove';
import { DeveloperAccountSection } from './DeveloperAccountSection';
import { PageAnchors } from '../../components/PageAnchors';

export function SettingsPage() {
  const { t } = useTranslation();
  return (
    <div className="page">
      <h1 className="page-title">{t('nav.account')}</h1>
      <div className="tabs" role="tablist">
        <NavLink to="/settings" end role="tab">
          {t('settings.security')}
        </NavLink>
        <NavLink to="/settings/notifications" role="tab">
          {t('settings.notifications')}
        </NavLink>
        <NavLink to="/settings/shared" role="tab">
          {t('mine.shared_tab')}
        </NavLink>
        <NavLink to="/settings/local-vms" role="tab">
          {t('localvms.tab')}
        </NavLink>
        <NavLink to="/settings/developer-account" role="tab">
          {t('devacct.tab')}
        </NavLink>
      </div>
      <Routes>
        <Route
          index
          element={
            <>
              {/* 段落錨點（第二輪 R2-P2-4）：API 金鑰在很下面 */}
              <PageAnchors
                items={[
                  { id: 'acct-mfa', label: t('mfa.section') },
                  { id: 'acct-passkeys', label: t('passkey.title') },
                  { id: 'acct-sessions', label: t('sessions.title') },
                  { id: 'acct-apikeys', label: t('apikeys.title') },
                  { id: 'acct-access-log', label: t('mine.access_log') },
                ]}
              />
              <div id="acct-mfa" className="anchor-target">
                <SecuritySection />
              </div>
              <div id="acct-passkeys" className="anchor-target">
                <PasskeysSection />
                <SsoLinksSection />
              </div>
              <div id="acct-sessions" className="anchor-target">
                <SessionsSection />
              </div>
              <div id="acct-apikeys" className="anchor-target">
                <ApiKeysSection />
              </div>
              <div id="acct-access-log" className="anchor-target">
                <MyAccessLogSection />
              </div>
            </>
          }
        />
        <Route path="developer-account" element={<DeveloperAccountSection />} />
        <Route path="notifications" element={<NotifySection />} />
        <Route path="shared" element={<SharedWithMeSection />} />
        <Route path="local-vms" element={<LocalVmsSection />} />
        <Route path="local-vms/approve" element={<LocalVmsApprove />} />
      </Routes>
    </div>
  );
}
